import {observable} from 'mobx'

export default class AppStore {
    @observable alert;

    @observable payment;
}
